import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home.vue'
import Final from '@/pages/final.vue'
import Scene from '@/components/scene.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {

      }
    },
    {
      path: '/breathing',
      name: 'Breathing',
      component: Scene,
      meta: {
        text: [
          ['There is a breath', 'Between the lines'],
          ['Shh! A hush in the', 'Hues of creative creed'],
          ['We inhale the Now', 'We exhale the how']
        ]
      }
    },
    {
      path: '/feeling',
      name: 'Feeling',
      component: Scene,
      meta: {
        text: [
          ['Energise. Mobilise. Actualise...'],
          ['... Love. What. We Do.', ''],
          ['The heart beat of a community,', 'Pumping out creativity']
        ]
      }
    },
    {
      path: '/seeing',
      name: 'Seeing',
      component: Scene,
      meta: {
        text: [
          ['Adapting the years.', 'Erasing the fears.'],
          ['Seeing in the dark.', 'Expanding the spark'],
          ['Clarity comes']
        ]
      }
    },
    {
      path: '/thinking',
      name: 'Thinking',
      component: Scene,
      meta: {
        text: [
          ['In waves. In likes.', 'In digital identity.'],
          ['Free to be. To grow.', 'To build the legacy'],
          ['Lighting up what', 'The future holds...']
        ]
      }
    },
    {
      path: '/tasting',
      name: 'Tasting',
      component: Scene,
      meta: {
        text: [
          ['Tasting the pallet.', 'Sharing the story'],
          ['Silence stop and stare.', 'And satiate'],
          ['The desire to create']
        ]
      }
    },
    {
      path: '/moving',
      name: 'Moving',
      component: Scene,
      meta: {
        text: [
          ['We go on. We keep becoming...'],
          ['10 years of being, feeling...'],
          ['10 years of digital experiences']
        ]
      }
    },
    {
      path: '/10years',
      name: 'Final',
      component: Final,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js